<div class="page-layout carded fullwidth">
    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">
        <!-- CONTENT HEADER -->
        <div
            class="header accent p-24"
            fxLayout="row"
            fxLayoutAlign="start center"
        >
            <h2 class="m-0">
                <span *ngIf="!editar_nombre" class="px-20">{{
                    evaluacion?.nombre
                }}</span>
                <input
                    placeholder="Nombre"
                    matInput
                    [(ngModel)]="nombre"
                    *ngIf="editar_nombre"
                />
                <mat-icon
                    *ngIf="editar_nombre"
                    aria-hidden="false"
                    aria-label="Editar estado"
                    (click)="updateName(nombre)"
                    >save</mat-icon
                >
                <!--<a *ngIf="is_owner && evaluacion?.estado!='CERRADO'" (click)="editar_nombre=true">Editar</a>-->
                <mat-icon
                    *ngIf="is_eval_creador && evaluacion?.estado != 'CERRADO'"
                    aria-hidden="false"
                    aria-label="Editar nombre"
                    (click)="editar_nombre = true"
                    >edit</mat-icon
                >
                <span
                    *ngIf="!editar_nombre && evaluacion?.version > 0"
                    class="px-20"
                    >(Versión {{ evaluacion?.version }})</span
                >
            </h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <!-- CONTENT TOOLBAR -->
            <div class="toolbar px-24 py-8">
                <div>
                    <!--   -->
                    <mat-horizontal-stepper
                        #stepper
                        [selectedIndex]="this.selectedStatus"
                        (click)="changeStatus($event)"
                        style="max-height: 60px"
                    >
                        <mat-step
                            [editable]="isEditable"
                            [completed]="isThisStepDone0"
                            [state]="isStepDone0"
                        >
                            <form [formGroup]="preiniciadoFormGroup">
                                <ng-template matStepLabel
                                    >Preiniciado</ng-template
                                >
                                <input
                                    matInput
                                    placeholder="Last name, First name"
                                    required
                                    class="invisible example-full-width"
                                />
                            </form>
                        </mat-step>
                        <mat-step
                            [editable]="isEditable"
                            [completed]="isThisStepDone1"
                            [state]="isStepDone1"
                        >
                            <form [formGroup]="iniciadoFormGroup">
                                <ng-template matStepLabel>Iniciado</ng-template>
                                <input
                                    matInput
                                    placeholder="Last name, First name"
                                    required
                                    class="invisible example-full-width"
                                />
                            </form>
                        </mat-step>
                        <mat-step
                            [editable]="isEditable"
                            [completed]="isThisStepDone2"
                            [state]="isStepDone2"
                        >
                            <form [formGroup]="completadoFormGroup">
                                <ng-template matStepLabel
                                    >Completado</ng-template
                                >
                                <input
                                    matInput
                                    placeholder="Last name, First name"
                                    required
                                    class="invisible example-full-width"
                                />
                            </form>
                        </mat-step>
                        <mat-step
                            [editable]="isEditable"
                            [completed]="isThisStepDone3"
                            [state]="isStepDone3"
                        >
                            <form [formGroup]="aprobadoFormGroup">
                                <ng-template matStepLabel>Aprobado</ng-template>
                                <input
                                    matInput
                                    placeholder="Last name, First name"
                                    required
                                    class="invisible example-full-width"
                                />
                            </form>
                        </mat-step>
                        <mat-step
                            [editable]="isEditable"
                            [completed]="isThisStepDone4"
                            [state]="isStepDone4"
                        >
                            <form [formGroup]="cerradoFormGroup">
                                <ng-template matStepLabel>Cerrado</ng-template>
                                <input
                                    matInput
                                    placeholder="Last name, First name"
                                    required
                                    class="invisible example-full-width"
                                />
                            </form>
                        </mat-step>
                    </mat-horizontal-stepper>
                </div>
                <div fxFlex fxLayout="row" fxLayoutAlign="end center">
                    <button
                        mat-button
                        (click)="print()"
                        mat-flat-button
                        color="primary"
                        class="add-row"
                    >
                        <mat-icon aria-hidden="false" aria-label="print"
                            >print</mat-icon
                        >
                    </button>
                    <button
                        *ngIf="
                            (is_eval_owner || is_eval_creador) &&
                            evaluacion?.estado != 'PRE_INICIADO'
                        "
                        mat-button
                        (click)="copiar()"
                        mat-flat-button
                        color="primary"
                        class="add-row"
                    >
                        <mat-icon aria-hidden="false" aria-label="Copiar"
                            >file_copy</mat-icon
                        >
                        Copiar
                    </button>
                    <button
                        *ngIf="
                            (is_eval_owner || is_eval_creador) &&
                            evaluacion?.estado == 'APROBADO'
                        "
                        mat-button
                        (click)="versionar()"
                        mat-flat-button
                        color="primary"
                        class="add-row"
                    >
                        <mat-icon
                            *ngIf="
                                (is_eval_owner || is_eval_creador) &&
                                evaluacion?.estado == 'APROBADO'
                            "
                            aria-hidden="false"
                            aria-label="Versionar"
                            >call_split</mat-icon
                        >
                        Versionar
                    </button>
                    <button
                        *ngIf="
                            is_eval_owner &&
                            (evaluacion?.estado == 'COMPLETADO' ||
                                evaluacion?.estado == 'APROBADO')
                        "
                        mat-button
                        (click)="rechazar()"
                        mat-flat-button
                        color="primary"
                        class="add-row"
                    >
                        <mat-icon
                            *ngIf="
                                is_eval_owner &&
                                evaluacion?.estado == 'COMPLETADO'
                            "
                            aria-hidden="false"
                            aria-label="Rechazar"
                            >undo</mat-icon
                        >
                        Rechazar
                    </button>
                    <button
                        mat-button
                        (click)="navegateTo('/mis-evaluaciones', '')"
                        mat-flat-button
                        color="primary"
                        class="add-row"
                    >
                        <mat-icon aria-hidden="false" aria-label="Salir"
                            >exit_to_app</mat-icon
                        >
                        Salir
                    </button>
                </div>
            </div>
            <!-- / CONTENT TOOLBAR -->

            <!-- CONTENT -->
            <div class="content p-24" style="max-height: 200px !important">
                <div id="scan" class="p-24" fxLayout="row" xFlex="100">
                    <div
                        fxLayout="column"
                        fxFlex="100"
                        fxFlex.gt-sm="100"
                        fxFlex.gt-md="50"
                    >
                        <div
                            class="profile-box info-box general"
                            fxLayout="column"
                        >
                            <table class="summary">
                                <tr class="code">
                                    <td class="label">Tipo de evaluación</td>
                                    <td class="value">
                                        <span
                                            *ngIf="!editar_tipo"
                                            class="px-20"
                                            >{{
                                                evaluacion?.tipo?.nombre
                                            }}</span
                                        >
                                        <mat-form-field
                                            *ngIf="editar_tipo"
                                            fxFlex
                                        >
                                            <mat-label
                                                >Tipo de evaluación</mat-label
                                            >
                                            <mat-select
                                                [(ngModel)]="evaluacion.tipo"
                                                class="roleSelect"
                                                (selectionChange)="
                                                    selectTipo($event)
                                                "
                                            >
                                                <mat-option
                                                    *ngFor="
                                                        let tipo of tiposEvaluacion
                                                    "
                                                    [value]="tipo"
                                                >
                                                    {{ tipo.nombre }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <a
                                            *ngIf="
                                                is_eval_creador &&
                                                evaluacion?.estado ==
                                                    'PRE_INICIADO'
                                            "
                                            (click)="editar_tipo = true"
                                            >Editar</a
                                        >
                                        <!--<mat-icon *ngIf="(is_owner && evaluacion?.estado=='PRE_INICIADO') || (is_eval_creador)" aria-hidden="false" aria-label="Editar estado" (click)="editar_tipo=true" >edit</mat-icon>-->
                                    </td>
                                </tr>

                                <tr>
                                    <td class="label">
                                        Estructura jerárquica / Nodo
                                    </td>
                                    <td class="value">
                                        <span
                                            class="px-20"
                                            *ngIf="
                                                evaluacion?.estructuraJerarquica !=
                                                null
                                            "
                                            >{{
                                                evaluacion?.estructuraJerarquica
                                                    ?.nombre
                                            }}
                                            /
                                            {{
                                                evaluacion
                                                    ?.nodoEstructuraJerarquica
                                                    ?.nombre
                                            }}</span
                                        >
                                        <a
                                            *ngIf="
                                                is_eval_creador &&
                                                evaluacion?.estado ==
                                                    'PRE_INICIADO'
                                            "
                                            (click)="openDialog()"
                                            >Editar</a
                                        >
                                        <!--<mat-icon  aria-hidden="false" aria-label="Editar estado" (click)="openDialog()" >edit</mat-icon>-->
                                    </td>
                                </tr>

                                <tr>
                                    <td class="label">Escenario</td>
                                    <td class="value">
                                        <span
                                            *ngIf="!editar_escenario"
                                            class="px-20"
                                            >{{
                                                evaluacion?.escenario?.nombre
                                            }}</span
                                        >
                                        <mat-form-field
                                            *ngIf="editar_escenario"
                                            fxFlex
                                        >
                                            <mat-label>Escenario</mat-label>
                                            <mat-select
                                                [(ngModel)]="
                                                    evaluacion.escenario
                                                "
                                                class="roleSelect"
                                                (selectionChange)="
                                                    selectEscenario($event)
                                                "
                                            >
                                                <mat-option
                                                    *ngFor="
                                                        let escenario of escenarios
                                                    "
                                                    [value]="escenario"
                                                >
                                                    {{ escenario.nombre }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <a
                                            *ngIf="
                                                is_eval_creador &&
                                                (evaluacion?.estado ==
                                                    'INICIADO' ||
                                                    evaluacion?.estado ==
                                                        'PRE_INICIADO')
                                            "
                                            (click)="editar_escenario = true"
                                            >Editar</a
                                        >
                                        <!--<mat-icon *ngIf="(is_owner && evaluacion?.estado=='PRE_INICIADO') || (is_eval_creador)" aria-hidden="false" aria-label="Editar estado" (click)="editar_escenario=true" >edit</mat-icon>-->
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <div
                        fxLayout="column"
                        fxFlex="100"
                        fxFlex.gt-sm="100"
                        fxFlex.gt-md="50"
                    >
                        <div
                            class="profile-box info-box general"
                            fxLayout="column"
                        >
                            <table class="summary">
                                <tr class="code">
                                    <td class="label">Dueño</td>
                                    <td class="value">
                                        <span
                                            *ngIf="!editar_dueno"
                                            class="px-20"
                                            >{{
                                                evaluacion?.owner
                                                    ?.nombreCompleto
                                            }}</span
                                        >
                                        <mat-form-field
                                            *ngIf="editar_dueno"
                                            fxFlex
                                        >
                                            <mat-label>Dueño</mat-label>
                                            <mat-select
                                                [(ngModel)]="evaluacion.owner"
                                                class="roleSelect"
                                                (selectionChange)="
                                                    selectDueno($event)
                                                "
                                            >
                                                <ng-container
                                                    *ngFor="
                                                        let usuario of evaluacion
                                                            .nodoEstructuraJerarquica
                                                            .usuarios
                                                    "
                                                >
                                                    <mat-option
                                                        *ngIf="
                                                            esOwnersGroup(
                                                                usuario
                                                            )
                                                        "
                                                        [value]="usuario"
                                                    >
                                                        {{
                                                            usuario.nombreCompleto
                                                        }}
                                                    </mat-option>
                                                </ng-container>
                                                <!--
                                        <mat-option *ngFor="let usuario of evaluacion.nodoEstructuraJerarquica.usuarios" *ngIf="esOwnersGroup(usuario)" [value]="usuario">
                                            {{usuario.nombreCompleto}}
                                        </mat-option>
                                        -->
                                            </mat-select>
                                        </mat-form-field>
                                        <a
                                            *ngIf="is_eval_creador"
                                            (click)="editar_dueno = true"
                                            >Editar</a
                                        >
                                        <!--<mat-icon *ngIf="(is_owner && evaluacion?.estado=='PRE_INICIADO') || (is_eval_creador)" aria-hidden="false" aria-label="Editar estado" (click)="editar_dueno=true" >edit</mat-icon>-->
                                    </td>
                                </tr>

                                <tr>
                                    <td class="label">Fecha inicio</td>
                                    <td class="value">
                                        <span
                                            *ngIf="!editar_fecha_inicio"
                                            class="px-20"
                                            >{{
                                                evaluacion?.fechaInicio
                                                    | date : "dd/MM/yyyy"
                                            }}</span
                                        >
                                        <mat-form-field
                                            color="accent"
                                            *ngIf="editar_fecha_inicio"
                                            fxFlex
                                        >
                                            <mat-label
                                                >Fecha de Inicio</mat-label
                                            >
                                            <input
                                                matInput
                                                [matDatepicker]="picker1"
                                                [(ngModel)]="fechaInicio"
                                                (dateChange)="
                                                    selectFechaInicio($event)
                                                "
                                            />
                                            <mat-datepicker-toggle
                                                matSuffix
                                                [for]="picker1"
                                            ></mat-datepicker-toggle>
                                            <mat-datepicker
                                                #picker1
                                            ></mat-datepicker>
                                        </mat-form-field>
                                        <a
                                            *ngIf="
                                                is_eval_creador &&
                                                evaluacion?.estado ==
                                                    'PRE_INICIADO'
                                            "
                                            (click)="editar_fecha_inicio = true"
                                            >Editar</a
                                        >
                                        <!--<mat-icon *ngIf="(is_owner && evaluacion?.estado=='PRE_INICIADO') || (is_eval_creador)" aria-hidden="false" aria-label="Editar estado" (click)="editar_fecha_inicio=true" >edit</mat-icon>-->
                                    </td>
                                </tr>

                                <tr>
                                    <td class="label">Fecha finalización</td>
                                    <td class="value">
                                        <span
                                            *ngIf="!editar_fecha_fin"
                                            class="px-20"
                                            >{{
                                                evaluacion?.fechaFin
                                                    | date : "dd/MM/yyyy"
                                            }}</span
                                        >
                                        <mat-form-field
                                            color="accent"
                                            *ngIf="editar_fecha_fin"
                                            fxFlex
                                        >
                                            <mat-label
                                                >Fecha finalización</mat-label
                                            >
                                            <input
                                                matInput
                                                [matDatepicker]="picker2"
                                                [min]="fechaInicio"
                                                [(ngModel)]="fechaFin"
                                                (dateChange)="
                                                    selectFechaFin($event)
                                                "
                                            />
                                            <mat-datepicker-toggle
                                                matSuffix
                                                [for]="picker2"
                                            ></mat-datepicker-toggle>
                                            <mat-datepicker
                                                #picker2
                                            ></mat-datepicker>
                                        </mat-form-field>
                                        <a
                                            *ngIf="
                                                is_eval_creador &&
                                                evaluacion?.estado != 'CERRADO'
                                            "
                                            (click)="editar_fecha_fin = true"
                                            >Editar</a
                                        >
                                        <!--<mat-icon *ngIf="(is_owner && evaluacion?.estado=='PRE_INICIADO') || (is_eval_creador)" aria-hidden="false" aria-label="Editar estado" (click)="editar_fecha_fin=true" >edit</mat-icon>-->
                                    </td>
                                </tr>
                                <tr>
                                    <td class="label">Creado por</td>
                                    <td class="value">
                                        <span class="px-20">{{
                                            evaluacion?.creador?.nombreCompleto
                                        }}</span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <!-- / CONTENT -->

            <!-- TABS -->

            <div class="content">
                <mat-tab-group
                    dynamicHeight
                    (selectedTabChange)="tabChanged($event)"
                >
                    <mat-tab label="Objetivos">
                        <div
                            class="widget-group p-12"
                            fxLayout="column wrap"
                            fxFlex="100"
                            *fuseIfOnDom
                        >
                            <div class="content p-24">
                                <button
                                    *ngIf="
                                        is_eval_owner &&
                                        evaluacion?.estado != 'CERRADO' &&
                                        evaluacion?.estado != 'APROBADO'
                                    "
                                    mat-button
                                    (click)="openDialogObjetivos('Add', {})"
                                    mat-flat-button
                                    color="primary"
                                    class="add-row"
                                >
                                    Agregar objetivo
                                </button>

                                <table
                                    mat-table
                                    [dataSource]="evaluacion?.objetivos"
                                    #mytable
                                    class="my-table mat-elevation-z8"
                                >
                                    <!--- Note that these columns can be defined in any order.
                                       The actual rendered columns are set as a property on the row definition" -->

                                    <!-- User Column -->
                                    <ng-container matColumnDef="nombre">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Nombre.
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.nombre }}
                                        </td>
                                    </ng-container>

                                    <!-- Role Column -->
                                    <ng-container matColumnDef="descripcion">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Descripcion.
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.descripcion }}
                                        </td>
                                    </ng-container>

                                    <!-- Action Column -->
                                    <ng-container matColumnDef="action">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Acción
                                        </th>
                                        <td
                                            mat-cell
                                            *matCellDef="let element"
                                            class="action-link"
                                        >
                                            <a
                                                (click)="
                                                    openDialogEditObjetivo(
                                                        'Update',
                                                        element
                                                    )
                                                "
                                                *ngIf="
                                                    is_eval_owner &&
                                                    evaluacion?.estado !=
                                                        'CERRADO' &&
                                                    evaluacion?.estado !=
                                                        'APROBADO'
                                                "
                                                >Editar</a
                                            >
                                            <span
                                                *ngIf="
                                                    is_eval_owner &&
                                                    evaluacion?.estado !=
                                                        'CERRADO' &&
                                                    evaluacion?.estado !=
                                                        'APROBADO'
                                                "
                                            >
                                                |
                                            </span>
                                            <a
                                                (click)="
                                                    openDialogObjetivos(
                                                        'Delete',
                                                        element
                                                    )
                                                "
                                                *ngIf="
                                                    is_eval_owner &&
                                                    evaluacion?.estado !=
                                                        'CERRADO' &&
                                                    evaluacion?.estado !=
                                                        'APROBADO'
                                                "
                                                >Eliminar</a
                                            >
                                        </td>
                                    </ng-container>

                                    <tr
                                        mat-header-row
                                        *matHeaderRowDef="
                                            displayedColumnsObjetivos
                                        "
                                    ></tr>
                                    <tr
                                        mat-row
                                        *matRowDef="
                                            let row;
                                            columns: displayedColumnsObjetivos
                                        "
                                    ></tr>
                                </table>
                            </div>
                        </div>
                        <!-- / WIDGET GROUP -->
                    </mat-tab>

                    <mat-tab label="Analistas">
                        <!-- WIDGET GROUP -->
                        <div
                            class="widget-group"
                            fxLayout="column wrap"
                            fxFlex="100"
                            *fuseIfOnDom
                        >
                            <div class="content p-24">
                                <button
                                    *ngIf="
                                        is_eval_owner &&
                                        evaluacion?.estado != 'CERRADO' &&
                                        evaluacion?.estado != 'APROBADO'
                                    "
                                    mat-button
                                    (click)="openDialogUsuarios('Add', {})"
                                    mat-flat-button
                                    color="primary"
                                    class="add-row"
                                >
                                    Agregar usuario
                                </button>

                                <table
                                    mat-table
                                    [dataSource]="evaluacion?.usuarios"
                                    #mytable
                                    class="my-table mat-elevation-z8"
                                >
                                    <!--- Note that these columns can be defined in any order.
                                       The actual rendered columns are set as a property on the row definition" -->

                                    <!-- User Column -->
                                    <ng-container matColumnDef="nombre">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Nombre.
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.nombreCompleto }}
                                        </td>
                                    </ng-container>

                                    <!-- Role Column -->
                                    <ng-container
                                        matColumnDef="correoElectronico"
                                    >
                                        <th mat-header-cell *matHeaderCellDef>
                                            Usuario.
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.correoElectronico }}
                                        </td>
                                    </ng-container>

                                    <!-- Action Column -->
                                    <ng-container matColumnDef="action">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Acción
                                        </th>
                                        <td
                                            mat-cell
                                            *matCellDef="let element"
                                            class="action-link"
                                        >
                                            <a
                                                (click)="
                                                    openDialogUsuarios(
                                                        'Delete',
                                                        element
                                                    )
                                                "
                                                *ngIf="
                                                    is_eval_owner &&
                                                    evaluacion?.estado !=
                                                        'CERRADO' &&
                                                    evaluacion?.estado !=
                                                        'APROBADO'
                                                "
                                                >Eliminar</a
                                            >
                                        </td>
                                    </ng-container>

                                    <tr
                                        mat-header-row
                                        *matHeaderRowDef="
                                            displayedColumnsUsuarios
                                        "
                                    ></tr>
                                    <tr
                                        mat-row
                                        *matRowDef="
                                            let row;
                                            columns: displayedColumnsUsuarios
                                        "
                                    ></tr>
                                </table>
                            </div>
                        </div>
                        <!-- / WIDGET GROUP -->
                    </mat-tab>

                    <mat-tab label="Dimensiones">
                        <!-- WIDGET GROUP -->
                        <div
                            class="widget-group"
                            fxLayout="column wrap"
                            fxFlex="100"
                            *fuseIfOnDom
                        >
                            <div class="content p-24">
                                <button
                                    *ngIf="
                                        is_eval_owner &&
                                        evaluacion?.estado != 'APROBADO' &&
                                        evaluacion?.estado != 'CERRADO'
                                    "
                                    mat-button
                                    (click)="openDialogDimensiones('Add', {})"
                                    mat-flat-button
                                    color="primary"
                                    class="add-row"
                                >
                                    Agregar
                                </button>

                                <table
                                    mat-table
                                    [dataSource]="evaluacion?.dimensiones"
                                    #mytable
                                    class="my-table mat-elevation-z8"
                                >
                                    <!--- Note that these columns can be defined in any order.
                                       The actual rendered columns are set as a property on the row definition" -->

                                    <!-- User Column -->
                                    <ng-container matColumnDef="nombre">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Nombre
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.nombre }}
                                        </td>
                                    </ng-container>

                                    <!-- Role Column -->
                                    <ng-container matColumnDef="descripcion">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Descripción
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.descripcion }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="categorias">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Categorias
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            <mat-chip-list
                                                aria-label="Categorias"
                                            >
                                                <mat-chip
                                                    *ngFor="
                                                        let categoria of element.categorias
                                                    "
                                                    >{{ categoria }}</mat-chip
                                                >
                                            </mat-chip-list>
                                        </td>
                                    </ng-container>

                                    <!-- Action Column -->
                                    <ng-container matColumnDef="action">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Acción
                                        </th>
                                        <td
                                            mat-cell
                                            *matCellDef="let element"
                                            class="action-link"
                                        >
                                            <a
                                                (click)="
                                                    openDialogEditDimensiones(
                                                        'Update',
                                                        element
                                                    )
                                                "
                                                *ngIf="
                                                    is_eval_owner &&
                                                    evaluacion?.estado !=
                                                        'APROBADO' &&
                                                    evaluacion?.estado !=
                                                        'CERRADO'
                                                "
                                                >Editar</a
                                            >
                                            <span
                                                *ngIf="
                                                    is_eval_owner &&
                                                    evaluacion?.estado !=
                                                        'APROBADO' &&
                                                    evaluacion?.estado !=
                                                        'CERRADO'
                                                "
                                            >
                                                |
                                            </span>
                                            <a
                                                (click)="
                                                    openDialogDimensiones(
                                                        'Delete',
                                                        element
                                                    )
                                                "
                                                *ngIf="
                                                    is_eval_owner &&
                                                    evaluacion?.estado !=
                                                        'APROBADO' &&
                                                    evaluacion?.estado !=
                                                        'CERRADO'
                                                "
                                                >Eliminar</a
                                            >
                                        </td>
                                    </ng-container>

                                    <tr
                                        mat-header-row
                                        *matHeaderRowDef="
                                            displayedColumnsDimensiones
                                        "
                                    ></tr>
                                    <tr
                                        mat-row
                                        *matRowDef="
                                            let row;
                                            columns: displayedColumnsDimensiones
                                        "
                                    ></tr>
                                </table>
                            </div>
                        </div>
                        <!-- / WIDGET GROUP -->
                    </mat-tab>

                    <mat-tab
                        label="Id Riesgo"
                        *ngIf="evaluacion?.estado != 'PRE_INICIADO'"
                    >
                        <!-- WIDGET GROUP -->
                        <div
                            class="widget-group"
                            fxLayout="column wrap"
                            fxFlex="100"
                            *fuseIfOnDom
                        >
                            <div class="content p-24">
                                <button
                                    *ngIf="
                                        (is_team_member &&
                                            evaluacion?.estado == 'INICIADO') ||
                                        (is_eval_owner &&
                                            evaluacion?.estado != 'APROBADO' &&
                                            evaluacion?.estado != 'CERRADO')
                                    "
                                    mat-button
                                    (click)="openDialogRiesgos('Add', {})"
                                    mat-flat-button
                                    color="primary"
                                    class="add-row"
                                >
                                    Agregar riesgo
                                </button>

                                <table
                                    mat-table
                                    [dataSource]="evaluacion?.riesgos"
                                    #mytable
                                    class="my-table mat-elevation-z8"
                                >
                                    <!--- Note that these columns can be defined in any order.
                                       The actual rendered columns are set as a property on the row definition" -->

                                    <!-- User Column -->
                                    <ng-container matColumnDef="objetivo">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Objetivo
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.objetivo?.nombre }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="riesgo">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Riesgo
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.riesgo?.nombre }}
                                        </td>
                                    </ng-container>

                                    <!-- Action Column -->
                                    <ng-container matColumnDef="action">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Acción
                                        </th>
                                        <td
                                            mat-cell
                                            *matCellDef="let element"
                                            class="action-link"
                                        >
                                            <a
                                                (click)="
                                                    openDialogEditRiesgo(
                                                        'Update',
                                                        element
                                                    )
                                                "
                                                *ngIf="
                                                    (is_team_member &&
                                                        evaluacion?.estado ==
                                                            'INICIADO') ||
                                                    (is_eval_owner &&
                                                        evaluacion?.estado !=
                                                            'APROBADO' &&
                                                        evaluacion?.estado !=
                                                            'CERRADO')
                                                "
                                                >Editar</a
                                            >|
                                            <a
                                                (click)="
                                                    openDialogRiesgos(
                                                        'Delete',
                                                        element
                                                    )
                                                "
                                                *ngIf="
                                                    (is_team_member &&
                                                        evaluacion?.estado ==
                                                            'INICIADO') ||
                                                    (is_eval_owner &&
                                                        evaluacion?.estado !=
                                                            'APROBADO' &&
                                                        evaluacion?.estado !=
                                                            'CERRADO')
                                                "
                                                >Eliminar</a
                                            >
                                        </td>
                                    </ng-container>

                                    <tr
                                        mat-header-row
                                        *matHeaderRowDef="
                                            displayedColumnsRiesgos
                                        "
                                    ></tr>
                                    <tr
                                        mat-row
                                        *matRowDef="
                                            let row;
                                            columns: displayedColumnsRiesgos
                                        "
                                    ></tr>
                                </table>
                            </div>
                        </div>
                        <!-- / WIDGET GROUP -->
                    </mat-tab>

                    <mat-tab
                        label="Análisis inherente"
                        *ngIf="evaluacion?.estado != 'PRE_INICIADO'"
                    >
                        <!-- WIDGET GROUP -->
                        <div
                            class="widget-group"
                            fxLayout="column wrap"
                            fxFlex="100"
                            *fuseIfOnDom
                        >
                            <div class="content p-24">
                                <table
                                    mat-table
                                    [dataSource]="evaluacion?.riesgos"
                                    #tableAInherente
                                    class="my-table mat-elevation-z8"
                                >
                                    <ng-container matColumnDef="objetivo">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Objetivo
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.objetivo?.nombre }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="riesgo">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Riesgo
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.riesgo?.nombre }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="probabilidad">
                                        <th
                                            mat-header-cell
                                            *matHeaderCellDef
                                            mat-sort-header
                                        >
                                            Probabilidad
                                        </th>
                                        <td
                                            mat-cell
                                            *matCellDef="let element"
                                            style="min-width: 75px"
                                        >
                                            <mat-form-field
                                                *ngIf="
                                                    evaluacion?.dimensiones
                                                        .length == 0 &&
                                                    ((is_team_member &&
                                                        evaluacion?.estado ==
                                                            'INICIADO') ||
                                                        (is_eval_owner &&
                                                            evaluacion?.estado !=
                                                                'CERRADO' &&
                                                            evaluacion?.estado !=
                                                                'APROBADO'))
                                                "
                                            >
                                                <mat-label
                                                    >Probabilidad</mat-label
                                                >
                                                <mat-select
                                                    [compareWith]="
                                                        compareObjects
                                                    "
                                                    [(ngModel)]="
                                                        element
                                                            .topAnalisisInherente
                                                            .probabilidad
                                                    "
                                                    class="roleSelect"
                                                    (selectionChange)="
                                                        calcularAnalisisInherente(
                                                            element
                                                        )
                                                    "
                                                >
                                                    <mat-option
                                                        *ngFor="
                                                            let probabilidad of evaluacion
                                                                .escenario
                                                                .probabilidades
                                                        "
                                                        [value]="probabilidad"
                                                    >
                                                        {{
                                                            probabilidad.nombre
                                                        }}
                                                        ({{
                                                            probabilidad.valor
                                                                | number
                                                                    : "1.2-2"
                                                        }})
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                            <span
                                                *ngIf="
                                                    evaluacion?.dimensiones
                                                        .length > 0 ||
                                                    evaluacion?.estado ==
                                                        'CERRADO' ||
                                                    evaluacion?.estado ==
                                                        'APROBADO'
                                                "
                                                matTooltip="{{
                                                    element.topAnalisisInherente
                                                        ?.probabilidad?.nombre
                                                }}"
                                                matTooltipPosition="right"
                                                >{{
                                                    element.topAnalisisInherente
                                                        ?.probabilidad?.valor
                                                        | number : "1.2-2"
                                                }}</span
                                            >
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="impacto">
                                        <th
                                            mat-header-cell
                                            *matHeaderCellDef
                                            mat-sort-header
                                        >
                                            Impacto
                                        </th>
                                        <td
                                            mat-cell
                                            *matCellDef="let element"
                                            style="min-width: 75px"
                                        >
                                            <mat-form-field
                                                *ngIf="
                                                    evaluacion?.dimensiones
                                                        .length == 0 &&
                                                    ((is_team_member &&
                                                        evaluacion?.estado ==
                                                            'INICIADO') ||
                                                        (is_eval_owner &&
                                                            evaluacion?.estado !=
                                                                'CERRADO' &&
                                                            evaluacion?.estado !=
                                                                'APROBADO'))
                                                "
                                            >
                                                <mat-label>Impacto</mat-label>
                                                <mat-select
                                                    [compareWith]="
                                                        compareObjects
                                                    "
                                                    [(ngModel)]="
                                                        element
                                                            .topAnalisisInherente
                                                            .impacto
                                                    "
                                                    class="roleSelect"
                                                    (selectionChange)="
                                                        calcularAnalisisInherente(
                                                            element
                                                        )
                                                    "
                                                >
                                                    <mat-option
                                                        *ngFor="
                                                            let impacto of evaluacion
                                                                .escenario
                                                                .impactos
                                                        "
                                                        [value]="impacto"
                                                    >
                                                        {{ impacto.nombre }} ({{
                                                            impacto.valor
                                                                | number
                                                                    : "1.2-2"
                                                        }})
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                            <span
                                                *ngIf="
                                                    evaluacion?.dimensiones
                                                        .length > 0 ||
                                                    evaluacion?.estado ==
                                                        'CERRADO' ||
                                                    evaluacion?.estado ==
                                                        'APROBADO'
                                                "
                                                matTooltip="{{
                                                    element.topAnalisisInherente
                                                        ?.impacto?.nombre
                                                }}"
                                                matTooltipPosition="right"
                                                >{{
                                                    element.topAnalisisInherente
                                                        ?.impacto?.valor
                                                        | number : "1.2-2"
                                                }}</span
                                            >
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="exposicion">
                                        <th
                                            mat-header-cell
                                            *matHeaderCellDef
                                            mat-sort-header
                                        >
                                            Exposición
                                        </th>
                                        <td
                                            mat-cell
                                            *matCellDef="let element"
                                            style="min-width: 75px"
                                        >
                                            {{
                                                element.topAnalisisInherente
                                                    ?.exposicion
                                                    | number : "1.2-2"
                                            }}
                                        </td>
                                    </ng-container>

                                    <!--
                                   <ng-container matColumnDef="dimension">
                                     <th mat-header-cell *matHeaderCellDef mat-sort-header> Dimensión </th>
                                     <td mat-cell *matCellDef="let element"> {{element.topAnalisisInherente?.dimension?.nombre}} </td>
                                   </ng-container>-->

                                    <ng-container matColumnDef="categoria">
                                        <th
                                            mat-header-cell
                                            *matHeaderCellDef
                                            mat-sort-header
                                        >
                                            Categorías
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{
                                                element.topAnalisisInherente
                                                    ?.categoria
                                            }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="clasificacion">
                                        <th
                                            mat-header-cell
                                            *matHeaderCellDef
                                            mat-sort-header
                                        >
                                            Clasificación
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            <div
                                                [ngClass]="{
                                                    success:
                                                        element
                                                            .topAnalisisInherente
                                                            ?.clasificacion ==
                                                        'Aceptable',
                                                    error:
                                                        element
                                                            .topAnalisisInherente
                                                            ?.clasificacion ==
                                                        'Inaceptable',
                                                    warning:
                                                        element
                                                            .topAnalisisInherente
                                                            ?.clasificacion ==
                                                        'Atención'
                                                }"
                                            >
                                                {{
                                                    element.topAnalisisInherente
                                                        ?.clasificacion
                                                }}
                                            </div>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="action">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Acción
                                        </th>
                                        <td
                                            mat-cell
                                            *matCellDef="let element"
                                            class="action-link"
                                        >
                                            <a
                                                (click)="
                                                    openDialogAnalisisInherente(
                                                        'Update',
                                                        element
                                                    )
                                                "
                                                *ngIf="
                                                    ((is_team_member &&
                                                        evaluacion?.estado ==
                                                            'INICIADO') ||
                                                        (is_eval_owner &&
                                                            evaluacion?.estado !=
                                                                'CERRADO' &&
                                                            evaluacion?.estado !=
                                                                'APROBADO')) &&
                                                    evaluacion?.dimensiones
                                                        .length > 0
                                                "
                                                >Editar</a
                                            >
                                            <a
                                                (click)="
                                                    openDialogAnalisisInherente(
                                                        'View',
                                                        element
                                                    )
                                                "
                                                *ngIf="
                                                    (is_eval_owner ||
                                                        is_team_member) &&
                                                    (evaluacion?.estado ==
                                                        'CERRADO' ||
                                                        evaluacion?.estado ==
                                                            'APROBADO') &&
                                                    evaluacion?.dimensiones
                                                        .length > 0
                                                "
                                                >Ver</a
                                            >
                                            <!--<a (click)="openDialogAnalisisInherente('Delete',element)" *ngIf="(is_team_member && evaluacion?.estado=='INICIADO') && is_owner">Eliminar</a>-->
                                        </td>
                                    </ng-container>

                                    <tr
                                        mat-header-row
                                        *matHeaderRowDef="
                                            displayedColumnsAnalisisInherente
                                        "
                                    ></tr>
                                    <tr
                                        mat-row
                                        *matRowDef="
                                            let row;
                                            columns: displayedColumnsAnalisisInherente
                                        "
                                    ></tr>
                                </table>
                            </div>

                            <div class="content p-24">
                                <div class="chart-data">
                                    <!--
                                 <ngx-charts-heat-map
                                     [view]="view"
                                     [scheme]="colorScheme"
                                     [legend]="legend"
                                     [gradient] = "gradient"
                                     [showXAxisLabel]="showXAxisLabel"
                                     [showYAxisLabel]="showYAxisLabel"
                                     [xAxis]="xAxis"
                                     [yAxis]="yAxis"
                                     [xAxisLabel]="xAxisLabel"
                                     [yAxisLabel]="yAxisLabel"
                                     [results]="multi"
                                     (select)="onSelect($event)"
                                     (activate)="onActivate($event)"
                                     (deactivate)="onDeactivate($event)"
                                     >
                                   </ngx-charts-heat-map>-->
                                </div>
                            </div>
                        </div>
                        <!-- / WIDGET GROUP -->
                    </mat-tab>

                    <mat-tab
                        label="Análisis Residual"
                        *ngIf="evaluacion?.estado != 'PRE_INICIADO'"
                    >
                        <!-- WIDGET GROUP -->
                        <div
                            class="widget-group"
                            fxLayout="column wrap"
                            *fuseIfOnDom
                        >
                            <div class="content p-24" fxFlex="100">
                                <button
                                    mat-button
                                    (click)="printControlesCriticos()"
                                    mat-flat-button
                                    color="primary"
                                    class="add-row"
                                >
                                    <mat-icon
                                        aria-hidden="false"
                                        aria-label="print"
                                        >print</mat-icon
                                    >
                                    Controles Clave
                                </button>

                                <table
                                    mat-table
                                    [dataSource]="evaluacion?.riesgos"
                                    #mytable
                                    class="my-table mat-elevation-z8"
                                >
                                    <ng-container matColumnDef="objetivo">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Objetivo
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.objetivo?.nombre }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="riesgo">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Riesgo
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.riesgo?.nombre }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="probabilidad">
                                        <th
                                            mat-header-cell
                                            *matHeaderCellDef
                                            mat-sort-header
                                        >
                                            Probabilidad
                                        </th>
                                        <td
                                            mat-cell
                                            *matCellDef="let element"
                                            style="min-width: 80px"
                                        >
                                            <span
                                                matTooltip="{{
                                                    element.topAnalisisResidual
                                                        ?.probabilidad?.nombre
                                                }}"
                                                matTooltipPosition="right"
                                                >{{
                                                    element.topAnalisisResidual
                                                        ?.probabilidad?.valor
                                                        | number : "1.2-2"
                                                }}
                                            </span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="impacto">
                                        <th
                                            mat-header-cell
                                            *matHeaderCellDef
                                            mat-sort-header
                                        >
                                            Impacto
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            <span
                                                matTooltip="{{
                                                    element.topAnalisisResidual
                                                        ?.impacto?.nombre
                                                }}"
                                                matTooltipPosition="right"
                                                >{{
                                                    element.topAnalisisResidual
                                                        ?.impacto?.valor
                                                        | number : "1.2-2"
                                                }}
                                            </span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="exposicion">
                                        <th
                                            mat-header-cell
                                            *matHeaderCellDef
                                            mat-sort-header
                                        >
                                            Exp. residual
                                        </th>
                                        <td
                                            mat-cell
                                            *matCellDef="let element"
                                            style="min-width: 75px"
                                        >
                                            {{
                                                element.topAnalisisResidual
                                                    ?.exposicion
                                                    | number : "1.2-2"
                                            }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="control">
                                        <th
                                            mat-header-cell
                                            *matHeaderCellDef
                                            mat-sort-header
                                        >
                                            Control instalado
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{
                                                element.topAnalisisResidual
                                                    ?.control
                                            }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="costo">
                                        <th
                                            mat-header-cell
                                            *matHeaderCellDef
                                            mat-sort-header
                                        >
                                            Costo
                                        </th>
                                        <td
                                            mat-cell
                                            *matCellDef="let element"
                                            style="min-width: 50px"
                                        >
                                            {{
                                                element.topAnalisisResidual
                                                    ?.costo
                                            }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="esfuerzo">
                                        <th
                                            mat-header-cell
                                            *matHeaderCellDef
                                            mat-sort-header
                                        >
                                            Esfuerzo
                                        </th>
                                        <td
                                            mat-cell
                                            *matCellDef="let element"
                                            style="min-width: 50px"
                                        >
                                            {{
                                                element.topAnalisisResidual
                                                    ?.esfuerzo
                                            }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="nroControles">
                                        <th
                                            mat-header-cell
                                            *matHeaderCellDef
                                            mat-sort-header
                                        >
                                            Cant.
                                        </th>
                                        <td
                                            mat-cell
                                            *matCellDef="let element"
                                            style="min-width: 50px"
                                        >
                                            {{ element.cantidadControles }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="clasificacion">
                                        <th
                                            mat-header-cell
                                            *matHeaderCellDef
                                            mat-sort-header
                                        >
                                            Clasificación
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            <div
                                                [ngClass]="{
                                                    success:
                                                        element
                                                            .topAnalisisResidual
                                                            ?.clasificacion ==
                                                        'Aceptable',
                                                    error:
                                                        element
                                                            .topAnalisisResidual
                                                            ?.clasificacion ==
                                                        'Inaceptable',
                                                    warning:
                                                        element
                                                            .topAnalisisResidual
                                                            ?.clasificacion ==
                                                        'Atención'
                                                }"
                                            >
                                                {{
                                                    element.topAnalisisResidual
                                                        ?.clasificacion
                                                }}
                                            </div>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="action">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Acción
                                        </th>
                                        <td
                                            mat-cell
                                            *matCellDef="let element"
                                            class="action-link"
                                        >
                                            <div
                                                *ngIf="
                                                    element.topAnalisisInherente
                                                        ?.exposicion != null &&
                                                    ((is_team_member &&
                                                        evaluacion?.estado ==
                                                            'INICIADO') ||
                                                        (is_eval_owner &&
                                                            evaluacion?.estado !=
                                                                'CERRADO' &&
                                                            evaluacion?.estado !=
                                                                'APROBADO'))
                                                "
                                            >
                                                <a
                                                    (click)="
                                                        openDialogAnalisisResidual(
                                                            'Add',
                                                            element
                                                        )
                                                    "
                                                    >Editar</a
                                                >
                                                <!--<a (click)="openDialogAnalisisResidual('Delete',element)" >Eliminar</a>-->
                                            </div>
                                            <div
                                                *ngIf="
                                                    element.topAnalisisInherente
                                                        ?.exposicion != null &&
                                                    (is_team_member ||
                                                        is_eval_owner) &&
                                                        ((is_eval_owner &&
                                                            evaluacion?.estado ==
                                                                'CERRADO') ||
                                                            evaluacion?.estado ==
                                                                'APROBADO')
                                                "
                                            >
                                                <a
                                                    (click)="
                                                        openDialogAnalisisResidual(
                                                            'View',
                                                            element
                                                        )
                                                    "
                                                    >Ver</a
                                                >
                                            </div>
                                        </td>
                                    </ng-container>

                                    <tr
                                        mat-header-row
                                        *matHeaderRowDef="
                                            displayedColumnsAnalisisResidual
                                        "
                                    ></tr>
                                    <tr
                                        mat-row
                                        *matRowDef="
                                            let row;
                                            columns: displayedColumnsAnalisisResidual
                                        "
                                    ></tr>
                                </table>
                            </div>

                            <div class="content p-24">
                                <mat-card class="example-card">
                                    <mat-card-header>
                                        <mat-card-title
                                            >Mapa de calor</mat-card-title
                                        >
                                    </mat-card-header>

                                    <mat-card-content fxLayout="row" *ngIf="reenderizarMapaDeCalro">
                                        <ngx-charts-heat-map
                                            [view]="view"
                                            [scheme]="colorScheme"
                                            [legend]="false"
                                            [gradient]="gradient"
                                            [showXAxisLabel]="showXAxisLabel"
                                            [showYAxisLabel]="showYAxisLabel"
                                            [xAxis]="xAxis"
                                            [yAxis]="yAxis"
                                            [xAxisLabel]="xAxisLabel"
                                            [yAxisLabel]="yAxisLabel"
                                            [maxXAxisTickLength]="50"
                                            [trimXAxisTicks]="true"
                                            [maxYAxisTickLength]="50"
                                            [trimYAxisTicks]="true"
                                            [results]="multi"
                                            [customColors]="customColors"
                                            [tooltipDisabled]="false"
                                        >
                                            <ng-template
                                                #tooltipTemplate
                                                let-model="model"
                                            >
                                                <div
                                                    [innerHTML]="
                                                        tooltipText(model)
                                                    "
                                                    style="
                                                        font-size: 16px;
                                                        padding: 8px !important;
                                                    "
                                                ></div>
                                            </ng-template>
                                        </ngx-charts-heat-map>
                                    </mat-card-content>
                                </mat-card>
                            </div>

                            <div class="content p-24">
                                <mat-card class="example-card">
                                    <mat-card-header>
                                        <mat-card-title
                                            >En porcentajes</mat-card-title
                                        >
                                    </mat-card-header>

                                    <mat-card-content fxLayout="row">
                                        <ngx-charts-pie-grid
                                            [view]="view"
                                            fxFlex="100"
                                            [scheme]="colorScheme"
                                            [customColors]="customColorsPie"
                                            [results]="pieDataExposiciones"
                                        >
                                        </ngx-charts-pie-grid>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                        </div>
                        <!-- / WIDGET GROUP -->
                    </mat-tab>

                    <mat-tab
                        label="Respuestas"
                        *ngIf="evaluacion?.estado != 'PRE_INICIADO'"
                    >
                        <!-- WIDGET GROUP -->
                        <div
                            class="widget-group"
                            fxLayout="column wrap"
                            fxFlex="100"
                            *fuseIfOnDom
                        >
                            <div class="content p-24">
                                <h2>Controles sugeridos</h2>
                                <button
                                    mat-button
                                    (click)="printControlesSugeridos()"
                                    mat-flat-button
                                    color="primary"
                                    class="add-row"
                                >
                                    <mat-icon
                                        aria-hidden="false"
                                        aria-label="print"
                                        >print</mat-icon
                                    >
                                </button>

                                <button
                                    *ngIf="
                                        (is_team_member &&
                                            evaluacion?.estado == 'INICIADO') ||
                                        (is_eval_owner &&
                                            evaluacion?.estado != 'CERRADO' &&
                                            evaluacion?.estado != 'APROBADO')
                                    "
                                    mat-button
                                    (click)="
                                        openDialogControlSugerido('Add', {})
                                    "
                                    mat-flat-button
                                    color="primary"
                                    class="add-row"
                                >
                                    Agregar
                                </button>

                                <table
                                    mat-table
                                    [dataSource]="
                                        evaluacion?.controlesSugeridos
                                    "
                                    #mytable
                                    class="my-table mat-elevation-z8"
                                >
                                    <!--- Note that these columns can be defined in any order.
                                       The actual rendered columns are set as a property on the row definition" -->

                                    <!-- User Column -->
                                    <ng-container matColumnDef="riesgo">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Riesgo
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.riesgo?.nombre }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="control">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Controles sugeridos
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.control?.nombre }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="estructura">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Estructura Jerárquica
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.estructura?.nombre }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="nodo">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Nodo
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.nodo?.nombre }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="referente">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Referente
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{
                                                element.referente
                                                    ?.nombreCompleto
                                            }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="responsable">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Responsable
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.responsable }}
                                        </td>
                                    </ng-container>

                                    <!-- Action Column -->
                                    <ng-container matColumnDef="action">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Acción
                                        </th>
                                        <td
                                            mat-cell
                                            *matCellDef="let element"
                                            class="action-link"
                                        >
                                            <a
                                                (click)="
                                                    openDialogControlSugerido(
                                                        'Update',
                                                        element
                                                    )
                                                "
                                                *ngIf="
                                                    (is_team_member &&
                                                        evaluacion?.estado ==
                                                            'INICIADO') ||
                                                    (is_eval_owner &&
                                                        evaluacion?.estado !=
                                                            'CERRADO' &&
                                                        evaluacion?.estado !=
                                                            'APROBADO')
                                                "
                                                >Editar</a
                                            >
                                            <span
                                                *ngIf="
                                                    (is_team_member &&
                                                        evaluacion?.estado ==
                                                            'INICIADO') ||
                                                    (is_eval_owner &&
                                                        evaluacion?.estado !=
                                                            'CERRADO' &&
                                                        evaluacion?.estado !=
                                                            'APROBADO')
                                                "
                                                >|</span
                                            >
                                            <a
                                                (click)="
                                                    openDialogControlSugerido(
                                                        'Delete',
                                                        element
                                                    )
                                                "
                                                *ngIf="
                                                    (is_team_member &&
                                                        evaluacion?.estado ==
                                                            'INICIADO') ||
                                                    (is_eval_owner &&
                                                        evaluacion?.estado !=
                                                            'CERRADO' &&
                                                        evaluacion?.estado !=
                                                            'APROBADO')
                                                "
                                                >Eliminar</a
                                            >
                                            <a
                                                (click)="
                                                    openDialogControlSugerido(
                                                        'View',
                                                        element
                                                    )
                                                "
                                                *ngIf="
                                                    (is_team_member ||
                                                        is_eval_owner) &&
                                                    (evaluacion?.estado ==
                                                        'CERRADO' ||
                                                        evaluacion?.estado ==
                                                            'APROBADO')
                                                "
                                                >Ver</a
                                            >
                                        </td>
                                    </ng-container>

                                    <tr
                                        mat-header-row
                                        *matHeaderRowDef="
                                            displayedColumnsControlSugerido
                                        "
                                    ></tr>
                                    <tr
                                        mat-row
                                        *matRowDef="
                                            let row;
                                            columns: displayedColumnsControlSugerido
                                        "
                                    ></tr>
                                </table>
                            </div>

                            <div class="content p-24">
                                <h2>KRI</h2>
                                <button
                                    mat-button
                                    (click)="printKris()"
                                    mat-flat-button
                                    color="primary"
                                    class="add-row"
                                >
                                    <mat-icon
                                        aria-hidden="false"
                                        aria-label="print"
                                        >print</mat-icon
                                    >
                                </button>
                                <button
                                    *ngIf="
                                        (is_team_member &&
                                            evaluacion?.estado == 'INICIADO') ||
                                        (is_eval_owner &&
                                            evaluacion?.estado != 'CERRADO' &&
                                            evaluacion?.estado != 'APROBADO')
                                    "
                                    mat-button
                                    (click)="openDialogKri('Add', {})"
                                    mat-flat-button
                                    color="primary"
                                    class="add-row"
                                >
                                    Agregar
                                </button>

                                <table
                                    mat-table
                                    [dataSource]="evaluacion?.kris"
                                    #mytable
                                    class="my-table mat-elevation-z8"
                                >
                                    <ng-container matColumnDef="riesgo">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Riesgo
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.riesgo?.nombre }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="nombre">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Nombre
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.nombre }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="estructura">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Estructura Jerárquica
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.estructura?.nombre }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="nodo">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Nodo
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.nodo?.nombre }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="responsable">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Responsable
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{
                                                element.responsable
                                                    ?.nombreCompleto
                                            }}
                                        </td>
                                    </ng-container>

                                    <!-- Action Column -->
                                    <ng-container matColumnDef="action">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Acción
                                        </th>
                                        <td
                                            mat-cell
                                            *matCellDef="let element"
                                            class="action-link"
                                        >
                                            <a
                                                (click)="
                                                    openDialogKri(
                                                        'Update',
                                                        element
                                                    )
                                                "
                                                *ngIf="
                                                    (is_team_member &&
                                                        evaluacion?.estado ==
                                                            'INICIADO') ||
                                                    (is_eval_owner &&
                                                        evaluacion?.estado !=
                                                            'CERRADO' &&
                                                        evaluacion?.estado !=
                                                            'APROBADO')
                                                "
                                                >Editar</a
                                            >
                                            <span
                                                *ngIf="
                                                    (is_team_member &&
                                                        evaluacion?.estado ==
                                                            'INICIADO') ||
                                                    (is_eval_owner &&
                                                        evaluacion?.estado !=
                                                            'CERRADO' &&
                                                        evaluacion?.estado !=
                                                            'APROBADO')
                                                "
                                                >|</span
                                            >
                                            <a
                                                (click)="
                                                    openDialogKri(
                                                        'Delete',
                                                        element
                                                    )
                                                "
                                                *ngIf="
                                                    (is_team_member &&
                                                        evaluacion?.estado ==
                                                            'INICIADO') ||
                                                    (is_eval_owner &&
                                                        evaluacion?.estado !=
                                                            'CERRADO' &&
                                                        evaluacion?.estado !=
                                                            'APROBADO')
                                                "
                                                >Eliminar</a
                                            >
                                            <a
                                                (click)="
                                                    openDialogKri(
                                                        'View',
                                                        element
                                                    )
                                                "
                                                *ngIf="
                                                    (is_team_member ||
                                                        is_eval_owner) &&
                                                    (evaluacion?.estado ==
                                                        'CERRADO' ||
                                                        evaluacion?.estado ==
                                                            'APROBADO')
                                                "
                                                >Ver</a
                                            >
                                        </td>
                                    </ng-container>

                                    <tr
                                        mat-header-row
                                        *matHeaderRowDef="displayedColumnsKri"
                                    ></tr>
                                    <tr
                                        mat-row
                                        *matRowDef="
                                            let row;
                                            columns: displayedColumnsKri
                                        "
                                    ></tr>
                                </table>
                            </div>

                            <div class="content p-24">
                                <h2>Medidas de contingencia</h2>
                                <button
                                    mat-button
                                    (click)="printMedidasDeContingencia()"
                                    mat-flat-button
                                    color="primary"
                                    class="add-row"
                                >
                                    <mat-icon
                                        aria-hidden="false"
                                        aria-label="print"
                                        >print</mat-icon
                                    >
                                </button>
                                <button
                                    *ngIf="
                                        (is_team_member &&
                                            evaluacion?.estado == 'INICIADO') ||
                                        (is_eval_owner &&
                                            evaluacion?.estado != 'CERRADO' &&
                                            evaluacion?.estado != 'APROBADO')
                                    "
                                    mat-button
                                    (click)="
                                        openDialogMedidasDeContingencia(
                                            'Add',
                                            {}
                                        )
                                    "
                                    mat-flat-button
                                    color="primary"
                                    class="add-row"
                                >
                                    Agregar
                                </button>

                                <table
                                    mat-table
                                    [dataSource]="
                                        evaluacion?.medidasDeContingencia
                                    "
                                    #mytable
                                    class="my-table mat-elevation-z8"
                                >
                                    <ng-container matColumnDef="riesgo">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Riesgo
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.riesgo.nombre }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="medida">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Medida de contingencia
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.medida }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="estructura">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Estructura Jerárquica
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.estructura.nombre }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="nodo">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Nodo
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.nodo.nombre }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="referente">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Referente
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{
                                                element.referente
                                                    ?.nombreCompleto
                                            }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="responsable">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Responsable
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.responsable }}
                                        </td>
                                    </ng-container>

                                    <!-- Action Column -->
                                    <ng-container matColumnDef="action">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Acción
                                        </th>
                                        <td
                                            mat-cell
                                            *matCellDef="let element"
                                            class="action-link"
                                        >
                                            <a
                                                (click)="
                                                    openDialogMedidasDeContingencia(
                                                        'Update',
                                                        element
                                                    )
                                                "
                                                *ngIf="
                                                    (is_team_member &&
                                                        evaluacion?.estado ==
                                                            'INICIADO') ||
                                                    (is_eval_owner &&
                                                        evaluacion?.estado !=
                                                            'CERRADO' &&
                                                        evaluacion?.estado !=
                                                            'APROBADO')
                                                "
                                                >Editar</a
                                            >
                                            <span
                                                *ngIf="
                                                    (is_team_member &&
                                                        evaluacion?.estado ==
                                                            'INICIADO') ||
                                                    (is_eval_owner &&
                                                        evaluacion?.estado !=
                                                            'CERRADO' &&
                                                        evaluacion?.estado !=
                                                            'APROBADO')
                                                "
                                                >|</span
                                            >
                                            <a
                                                (click)="
                                                    openDialogMedidasDeContingencia(
                                                        'Delete',
                                                        element
                                                    )
                                                "
                                                *ngIf="
                                                    (is_team_member &&
                                                        evaluacion?.estado ==
                                                            'INICIADO') ||
                                                    (is_eval_owner &&
                                                        evaluacion?.estado !=
                                                            'CERRADO' &&
                                                        evaluacion?.estado !=
                                                            'APROBADO')
                                                "
                                                >Eliminar</a
                                            >
                                            <a
                                                (click)="
                                                    openDialogMedidasDeContingencia(
                                                        'View',
                                                        element
                                                    )
                                                "
                                                *ngIf="
                                                    (is_team_member ||
                                                        is_eval_owner) &&
                                                    (evaluacion?.estado ==
                                                        'CERRADO' ||
                                                        evaluacion?.estado ==
                                                            'APROBADO')
                                                "
                                                >Ver</a
                                            >
                                        </td>
                                    </ng-container>

                                    <tr
                                        mat-header-row
                                        *matHeaderRowDef="
                                            displayedColumnsMedidasDeContingencia
                                        "
                                    ></tr>
                                    <tr
                                        mat-row
                                        *matRowDef="
                                            let row;
                                            columns: displayedColumnsMedidasDeContingencia
                                        "
                                    ></tr>
                                </table>
                            </div>
                        </div>
                        <!-- / WIDGET GROUP -->
                    </mat-tab>

                    <mat-tab
                        label="Mediciones"
                        *ngIf="evaluacion?.estado != 'PRE_INICIADO'"
                    >
                        <!-- WIDGET GROUP -->
                        <div
                            class="widget-group"
                            fxLayout="column wrap"
                            fxFlex="100"
                            *fuseIfOnDom
                        >
                            <div
                                class="content p-24"
                                *ngFor="let kri of evaluacion?.kris"
                            >
                                <h2>{{ kri.nombre }}</h2>

                                <mediciones-list
                                    [kri]="kri"
                                    [action]="action"
                                    *ngIf="kri.id != null && action != 'Delete'"
                                ></mediciones-list>
                            </div>
                        </div>
                        <!-- / WIDGET GROUP -->
                    </mat-tab>
                </mat-tab-group>
            </div>
            <!-- TABS fin -->
        </div>
        <!-- / CONTENT CARD -->
    </div>
    <!-- / CENTER -->
</div>
